// @ts-check
export const ENTER = 'ENTER';
export const LEAVE = 'LEAVE';
export const BROADCAST_OPEN = 'BROADCAST_OPEN';
export const BROADCAST_SHUT = 'BROADCAST_SHUT';
export const LEAVE_ALL = 'LEAVE_ALL';
